// Separate file for the process object required so that constants.ts can be imported by pre-webpacked web workers
export const IS_TEST_ENV: boolean =
  process.env.REACT_APP_ENVIRONMENT !== 'prod';

export const api_host_suffix: string = ((): string => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'prod':
      return '.api.goldspot.ca';
    case 'test':
      return '.test.api.goldspot.ca';
    case 'test2':
      return '.api.test2.als.app';
    default:
      return '.test.api.goldspot.ca';
  }
})();

export const apiUrls: Record<string, string> = {
  tessellation: `https://tessellation${api_host_suffix}`,
  projects: `https://projects${api_host_suffix}`,
  files: `https://files${api_host_suffix}`,
  company: `https://company${api_host_suffix}`,
};

export const appUrls: Record<string, string> = ((): Record<string, string> => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'prod':
      return {
        home: 'https://als.app',
        admin: 'https://admin.app.goldspot.ca',
        litholens: 'https://litholens.als.app',
      };
    case 'test':
      return {
        home: 'https://staging.als.app',
        admin: 'https://admin.staging.app.goldspot.ca',
        litholens: 'https://litholens.staging.als.app',
      };
    case 'test2':
      return {
        home: 'https://staging.test2.als.app',
        admin: 'https://admin.staging.test2.als.app',
        litholens: 'https://litholens.staging.test2.als.app',
      };
    default:
      return {
        home: 'https://staging.als.app',
        admin: 'https://admin.staging.app.goldspot.ca',
        litholens: 'https://litholens.staging.als.app',
      };
  }
})();
